import { Form, Switch, Tag } from 'antd';
import React from 'react';

interface JSONTransformEnableSwitchProps {
    isDetailMode: boolean | undefined;
    fieldName: string | number;
    isFeatureDisabled: boolean;
    setIsFeatureDisabled: (isFeatureDisabled: boolean) => void;
    fieldKey: number | string;
}

const JSONTransformEnableSwitch: React.FC<JSONTransformEnableSwitchProps> = ({
    isDetailMode,
    fieldName,
    fieldKey,
    isFeatureDisabled,
    setIsFeatureDisabled,
}) => {
    return (
        <Form.Item
            labelCol={{ span: 12 }}
            wrapperCol={{ span: 12 }}
            label="Feature is"
            name={[fieldName, 'jsonTransformEnabled']}
            fieldKey={[fieldKey, 'jsonTransformEnabled']}
            valuePropName="checked"
            className="m-0"
        >
            {isDetailMode ? (
                <span className="ant-form-text text-secondary">
                    <Tag color={!isFeatureDisabled ? 'blue' : 'default'}>
                        {!isFeatureDisabled ? 'ENABLED' : 'DISABLED'}
                    </Tag>
                </span>
            ) : (
                <Switch
                    title={isFeatureDisabled ? 'Enable feature' : 'Disable feature'}
                    checkedChildren="Enabled"
                    unCheckedChildren="Disabled"
                    onChange={(value): void => {
                        setIsFeatureDisabled(!value);
                    }}
                />
            )}
        </Form.Item>
    );
};

export default JSONTransformEnableSwitch;
